@if (showIntermission && !showTimer) {
  <app-intermission
    [label]="intermissionButtonLabel"
    (onContinue)="stopIntermission()"
  ></app-intermission>
}

@if (showTimer) {
  <div class="app-container app-flex app-flex-middle flex-column">
    <div class="app-word-display d-flex flex-column align-items-center justify-content-center">
      <p style="font-size: 500%">{{ timer }}</p>
    </div>
  </div>
}

@if (!showIntermission && !showTimer) {
  <div
    class="app-container vw-100 vh-100 d-flex align-items-center justify-content-center"
    >
    @if (!isVisible) {
      <div>
        <svg
          class="app-focus-marker"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        <app-button-navigation [type]="type" [readingMode]="mode === 'reading'"></app-button-navigation>
      </div>
    }
    @if (isVisible) {
      <div class="d-flex align-items-center justify-content-center">
        @if (!finishedTrial) {
          <div class="app-word-display d-flex flex-column align-items-center justify-content-center">
            <!-- ngFor is needed in order to show the fade out for every word -->
            @if (mode !== 'reading' && primer) {
              <div class="app-word-container">
                @for (need of [stimuli[id]]; track need) {
                  <div
                    class="app-priming-primer"
                    [ngClass]="{ visible: isVisible, invisible: !isVisible }"
                    [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
                    >
                    {{ displayPrimer | uppercase }}
                  </div>
                }
              </div>
            }
            @if (mode !== 'reading' && primer_blank) {
              <div class="app-word-container">
                @for (need of [stimuli[id]]; track need) {
                  <div
                    [ngClass]="{ visible: isVisible, invisible: !isVisible }"
                    [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
                  ></div>
                }
              </div>
            }
            @if (mode !== 'reading' && target && !primer && !primer_blank) {
              <div class="app-word-container">
                @for (need of [stimuli[id]]; track need) {
                  <div
                    [ngClass]="{ visible: isVisible, invisible: !isVisible }"
                    [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
                    (onKeypress)="checkAnswerAndLoadNextItem($event)"
                    >
                    {{ displayValue | lowercase }}
                  </div>
                }
              </div>
            }
            @if (mode !== 'reading' && target_blank && !primer && !primer_blank) {
              <div class="app-word-container">
                @for (need of [stimuli[id]]; track need) {
                  <div
                    [ngClass]="{ visible: isVisible, invisible: !isVisible }"
                    [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
                    (onKeypress)="checkAnswerAndLoadNextItem($event)"
                  ></div>
                }
              </div>
            }
            @if (mode === 'reading') {
              <div class="app-word-container">
                @for (need of [stimuli[id]]; track need) {
                  <div
                    [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
                    (onKeypress)="checkAnswerAndLoadNextItem($event)"
                    >
                    {{ displayText }}
                  </div>
                }
              </div>
            }
          </div>
        }
        <app-button-navigation [type]="type" [readingMode]="mode === 'reading'"></app-button-navigation>
      </div>
    }
  </div>
}
